export default __webpack_public_path__ + "static/media/userCheck.4a2d5bda.svg";